import { __decorate } from "tslib";
import { Component, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from "@angular/platform-browser";
let HashAndGoComponent = class HashAndGoComponent {
    constructor(httpClient, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.atms = [];
        this.lastOpenIndex = -1;
        this.activeTab = 1;
        this.citiesArray = [];
        this.showCities = false;
        this.showAtms = [];
        this.city = 'all';
        this.latitude = 44.4419211;
        this.longitude = 20.4830112;
        this.zoom = 7.2;
        this.checkedCity = '';
        this.waterColor = '';
        this.mainColor = '';
        this.secondaryColor = '';
        this.successColor = '';
        this.textColor = '';
        this.linkColor = '';
        this.tabColor = '';
        this.borderRadiusSmaller = '';
        this.styles = {};
        this.clusterStyle = {
            textSize: 32
        };
        this.title = 'ECD maps';
        this.lat = 44.4419211;
        this.lng = 20.4830112;
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.tabColor = this.themeService.getStyleAttribute('tab_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (targetElement.className !== 'menu_atm_holder2' &&
            targetElement.className !== 'fa fa-caret-down' &&
            targetElement.className !== 'menu_one') {
            this.closeCities();
        }
    }
    closeCities() {
        this.showCities = false;
    }
    ngOnInit() {
        this.setActive(1);
        this.styles = [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "saturation": "-21"
                    },
                    {
                        "gamma": "2.98"
                    },
                    {
                        "weight": "4.77"
                    },
                    {
                        "lightness": "20"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#2a4e6e"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ];
        this.themeService.getTheme().subscribe((data) => {
            this.waterColor = this.themeService.getStyleAttribute('map_water_color');
            for (let i = 0; i < this.styles.length; i++) {
                if (this.styles[i].featureType === 'water') {
                    this.styles[i].stylers[0].color = this.waterColor;
                }
            }
        });
    }
    ngAfterViewInit() {
        // this.agmMap.mapReady.subscribe(
        //     map => {
        //         const bounds: LatLngBounds = new google.maps.LatLngBounds();
        //         bounds.extend(new google.maps.LatLng(this.latitude - 0.01, this.longitude - 0.01));
        //         map.panToBounds(bounds);
        //     }
        // );
    }
    convertStringToNumber(value) {
        return +value;
    }
    clickedMarker(data, index, type) {
        if (type === 'atm') {
            data['isOpen'] = true;
            if (this.lastOpenIndex > -1) {
                this.atms[this.lastOpenIndex]['isOpen'] = false;
            }
            this.lastOpenIndex = index;
        }
    }
    markerClicked(event) {
    }
    setActive(tabId) {
        this.checkedCity = '';
        this.city = 'all';
        if (this.activeTab !== tabId) {
            this.activeTab = tabId;
        }
        this.httpClient.get('merchants').subscribe((result) => {
            this.atms = result;
            this.showAtms = this.atms;
            let j = 0;
            for (let i = 0; i < this.atms.length; i++) {
                if (this.citiesArray.indexOf(this.atms[i].city) === -1) {
                    this.citiesArray[j] = this.atms[i].city;
                    j++;
                }
            }
        });
    }
    clickCity() {
        this.showCities = !this.showCities;
    }
    chooseCity(city) {
        if (this.agmMap.zoom !== 7.2) {
            const latitude = 44.4419211;
            const longitude = 20.4830112;
            this.agmMap.triggerResize().then((success) => {
                this.agmMap._mapsWrapper.setCenter({ lat: latitude, lng: longitude });
                this.agmMap._mapsWrapper.setZoom(7.2);
            });
        }
        this.city = city;
        this.showAtms = [];
        if (city === 'all') {
            this.showAtms = this.atms;
        }
        else {
            let j = 0;
            for (let i = 0; i < this.atms.length; i++) {
                if (this.atms[i].city === this.city) {
                    this.showAtms[j] = this.atms[i];
                    j++;
                }
            }
        }
        this.checkedCity = city;
        this.showCities = false;
    }
    clickLocation(atm, index) {
        this.setActive(1);
        if (screen.height < 960) {
            this.myScrollContainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.zoom = 8;
        this.longitude = parseInt(atm.longitudes) + 0.7;
        this.latitude = parseInt(atm.latitude) + 0.4;
    }
};
HashAndGoComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    ViewChild('AgmMap')
], HashAndGoComponent.prototype, "agmMap", void 0);
__decorate([
    ViewChild('scrollMe')
], HashAndGoComponent.prototype, "myScrollContainer", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], HashAndGoComponent.prototype, "onDocumentClick", null);
HashAndGoComponent = __decorate([
    Component({
        selector: 'ecd-atms',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./hash-and-go.component.html")).default
    })
], HashAndGoComponent);
export { HashAndGoComponent };
